import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const SOURCE_CHOPE_CLOUD = 'chopeCloud';

interface TrackingState {
  source: string | null;
}

const initialState: TrackingState = {
  source: null,
};

const trackingSlice = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    setSource: (state, action: PayloadAction<string | null>) => ({
      ...state,
      source: action.payload,
    }),
  },
});

export const { setSource } = trackingSlice.actions;
export { SOURCE_CHOPE_CLOUD };
export type { TrackingState };

export const selectSource = (state: { tracking?: TrackingState }) => state.tracking?.source ?? null;
export const selectIsChopeCloud = (state: { tracking?: TrackingState }) => state.tracking?.source === SOURCE_CHOPE_CLOUD;

export default trackingSlice.reducer;
